var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-box",on:{"click":_vm.onClickSearch}},[_c('Icon',{attrs:{"name":"search"}}),_c('div',{staticClass:"search-desc"},[_vm._v("大家都在看")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }